import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { getResourceIcon } from 'src/components/blend-check/blendCheckIcons';

/**
 * One side of a comparison header. Two columns need the caption to tell Source from
 * Destination, and the caption already says what the resource is, so the bare name
 * is enough. A single panel has neither, so it falls back to `nameWithType`
 * ("Container 9ce84464") - a bare short uuid on its own says nothing.
 */
const BlendCardSide = ({ variant, caption, resource, single }) => (
  <div
    className={classNames('blend-compare__side', `blend-compare__side--${variant}`, {
      'blend-compare__side--row': single,
    })}
  >
    <FontAwesomeIcon className='blend-compare__icon' icon={getResourceIcon(resource?.type)} />
    {single ? (
      <div className='blend-compare__name'>{resource?.nameWithType || resource?.name}</div>
    ) : (
      <div className='blend-compare__text'>
        <div className='blend-compare__caption'>{caption}</div>
        <div className='blend-compare__name'>{resource?.name}</div>
      </div>
    )}
  </div>
);

BlendCardSide.propTypes = {
  variant: PropTypes.oneOf(['source', 'destination']).isRequired,
  caption: PropTypes.string.isRequired,
  resource: PropTypes.shape({
    name: PropTypes.string,
    nameWithType: PropTypes.string,
    type: PropTypes.string,
  }),
  single: PropTypes.bool,
};

BlendCardSide.defaultProps = { resource: null, single: false };

export default BlendCardSide;
